import React from 'react';
import { SeasonOverviewProps } from '../../types';
import DraftSummaryStrip from './DraftSummaryStrip';
import PositionProductionChart from './PositionProductionChart';

/**
 * SeasonOverview - Complete season view with draft, evolution, and production
 * Features:
 * - Draft summary strip at top
 * - Position production charts at bottom
 * - Integrated navigation between components
 */
const SeasonOverview: React.FC<SeasonOverviewProps> = ({
  data,
  onDraftPlayerClick,
  onWeekClick
}) => {
  return (
    <div className="space-y-8">
      {/* Draft Summary */}
      <DraftSummaryStrip
        draftPicks={data.draft_summary}
        onPlayerClick={onDraftPlayerClick}
      />


      {/* Position Production Charts */}
      <PositionProductionChart
        positionProduction={data.position_production}
        onWeekClick={onWeekClick}
      />
    </div>
  );
};

export default SeasonOverview;
